import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  STORE_STATUS_INITIALIZED,
  STORE_USER_FETCH_SITUATION,
  STORE_USER_SITUATION,
} from 'constants/store'
import { ErrorStore, Situation } from '@types'
import {
  createGenericSlice,
  GenericState,
  createReducers,
  ExtraReducers,
} from 'stores/generics'
import { Payload } from 'stores'

export type SituationState = Situation

type State = GenericState<SituationState>

export const initialState: State = {
  data: {
    background_check_status: 'pending',
    document_back_photo_status: 'pending',
    document_front_photo_status: 'pending',
    face_match_status: 'pending',
    has_email_validation: false,
    has_pending_terms_to_sign: false,
    ocr_status: 'pending',
    self_photo_status: 'pending',
    status: 'onboarding',
    legal_person_situation: [],
    has_facial_recognition: false,
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchUserSituation = createAsyncThunk<
  SituationState,
  Promise<Situation>,
  Payload
>(
  STORE_USER_FETCH_SITUATION,
  async (promise: Promise<SituationState>, { rejectWithValue }) => {
    try {
      const response = await promise
      return response
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  SituationState,
  Situation,
  Payload
>(fetchUserSituation, initialState.data)

const userSlice = createGenericSlice({
  name: STORE_USER_SITUATION,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = userSlice

const { clear, success } = actions

export { clear, success }

export default reducer
